import * as React from "react"; 
import { BuildPartGW } from "./BuildPartGW"
import { BDKalkCore } from "./BDKalkCore"
import { MakeNational } from "./BDKalkCore"
import { ChoiseControlBuildPart } from "./ChoiseControlBuildPart"
 
///////////////   BuildPartItem  ////////////////

export interface BuildPartItemVm {
    key:string,
    index: number, // Used for keeping track of what item is being hovered
    core: BDKalkCore,
    buildPart: BuildPartGW
}

export interface BuildPartItemStates {
    mouseState: string,
    inputActive: boolean,
    mergeButtonState: number, // 0: out, 1: out_Hover, 2:over, 3:pressed
    loadButtonState: number, // 0: out, 1: out_Hover, 2:over, 3:pressed
    delButtonState: number // 0: out, 1: out_Hover, 2:over, 3:pressed
}

export class BuildPartItem extends React.Component<BuildPartItemVm,BuildPartItemStates> {

    state: BuildPartItemStates = {
        mouseState: "out",
        inputActive: false,
        mergeButtonState: 0, // 0: out, 1: out_Hover, 2:over, 3:pressed
        loadButtonState: 0, // 0: out, 1: out_Hover, 2:over, 3:pressed
        delButtonState: 0 // 0: out, 1: out_Hover, 2:over, 3:pressed
    }

    // A check if this item matches the one presently being typed into (if any)
    GetInputActive() {
        var coreItem = this.props.core.GetInputItemBP()
        if (coreItem == null) {
            return false
        }
        else {
            if (coreItem.props.buildPart.GetId() == this.props.buildPart.GetId()) {
                return true
            }
            else {
                return false
            }
        }
    }

    // 
    constructor(props: BuildPartItemVm) {
        super(props)
        this.m_clickedArea = "none"
    }

    // SetLocation is used internally by sub controls to specify where the item has been clicked
    SetLocation(location: string) {
        this.m_clickedArea = location
    }

    // Mouse up handler
    onMouseUp() {
        this.setState({ mouseState: "hover" })
        this.m_choiseCtrl.setState({ hovering: true })
    }

    // Mouse out handler
    onMouseOut() {
        if (this.GetInputActive() == false) {
            this.setState({ mouseState: "out" })
            this.m_choiseCtrl.setState({ hovering: false })
            this.m_choiseCtrl.setState({ plusPressed: false })
            this.m_choiseCtrl.setState({ minusPressed: false })
            this.m_choiseCtrl.setState({ crossPressed: false })
        }
        else {
            this.setState({ mouseState: "out" })
        }
    }

    // Sets the amount to a new value and forces the affected displays to redraw instantly
    SetAmount(newAmount: number) {
        this.props.buildPart.SetAmount(newAmount)
        this.forceUpdate()
        this.props.core.RedrawTotalSum()
    }

    // Mouse over handler
    onMouseOver() {
        this.setState({ mouseState: "hover" })
        this.m_choiseCtrl.setState({ hovering: true })
    }

    // Mouse down (pressed) handler
    onMouseDown() {
        this.setState({ mouseState: "hover" })
    }

    // Mouse click handler
    onClick() {
        const area = this.m_clickedArea
        this.m_clickedArea = "none"
        this.props.core.HandleBuildPartItemClick(this, area)
    }

    // 
    public ConnectChoise(choiseCtrl: ChoiseControlBuildPart) {
        this.m_choiseCtrl = choiseCtrl
        this.m_clickedArea = "none"
    }

    // 
    GetAsTwoDecimalString(value: number) {
        var result = value.toString()
        var decimalsShown = 0
        var passedComma = false

        // Counting the decimals of the total sum string
        for (var i = 0; i < result.length; i++) {
            if (passedComma == true) {
                decimalsShown++
            }

            // Ensuring there is no more than two decimals shown
            if (decimalsShown > 2) {
                result = result.slice(0, i)
                break
            }

            if (result[i] == '.') {
                passedComma = true
            }
        }

        // Ensuring there is allways two decimals shown on the total sum 
        if (decimalsShown == 0) {
            result += ".00"
        }

        if (decimalsShown == 1) {
            result += "0"
        }

        return MakeNational(result)
    }
    
    public render() {
        var elements: Array<JSX.Element> = new Array<JSX.Element>()
        var arts = this.props.buildPart.GetArticles()

        var radioPos = this.props.core.GetPriceRadio()
        var flags = this.props.core.GetPriceFlags()

        const bgFile = "url(images/selectionLoadButtons.png)"
        var loadOffsetX = "-0px"
        var loadOffsetY = "-0px"
        var mergeOffsetX = "-33px"
        var mergeOffsetY = "-0px"
        var delOffsetX = "-128px"
        var delOffsetY = "-0px"
        var hoverstate = "out"
        const leftMargin = "20px"
        const left = "70px"
        const midLeft = "67px"
        const midRight = "55px"
        const rightMargin = "0px"

        const itemsHeight = 30
        const itemHeight = 17
        const artsTitleHeight = 22
        const titleHeight = 42
        const buildEditAreaHeight = 167
        const buttonsLeftMargin = "35px"
        const buttonsCenterMargin = "10px"
        const buttonsAreaHeight = "38px"
        const itemFontSize = "20px"
        const itemYAdjustment = "1px"
        const separationMargin = 22

        var showingExtended: boolean = ((this.props.core.GetSelectionID() == this.props.buildPart.GetId()) && (this.props.core.GetApp().state.ExtInfoUp == true)) ? true : false
        var keyIndex = 0

        // Contents
        for (var i = 0; (i < arts.length) && (showingExtended == true); i++) {
            if (arts[i].GetAmount() != 0) {
                const keyStr = (keyIndex++).toString()
                elements.push(<div key={keyStr} style={{ display: "flex", flexDirection: "row", width:"100%" }}>
                    <div style={{ width: "35px" }}></div>
                    <div style={{ color: "grey", width: "35px" }}>{arts[i].GetAmount()}</div>
                    <div style={{ color: "grey", width: "45px" }}>{arts[i].GetUnit()}</div>
                    <div style={{ color: "grey", width: "350px" }}>{arts[i].GetDescription()}</div>
                    <div style={{ color: "grey", width: "120px", textAlign: "right" }}>{arts[i].GetUnitPriceString(radioPos, flags, false, null)}</div>
                    <div style={{ color: "grey", width: "140px", textAlign: "right" }}>{arts[i].GetSumString(radioPos, flags)}</div>
                </div>)
            }
        }

        const BPAmount = (showingExtended == true) ? (elements.length) : 0
        var SubBPAmount = 0

        if (this.props.buildPart.GetIncludedBuildParts() != null) {
            SubBPAmount = (showingExtended == true) ? (this.props.buildPart.GetIncludedBuildParts().length) : 0

            // Adding the title area:
            if (SubBPAmount > 0) {
                const keyStr0 = (keyIndex++).toString()
                {/* separation margin */ }
                elements.push(<div key={keyStr0} style={{ width: "100%", height: (separationMargin.toString() + "px") }}>

                </div>)

                const keyStr1 = (keyIndex++).toString()

                {/* title area */ }
                elements.push(<div key={keyStr1} style={{ width: "100%", height: (titleHeight.toString() + "px") }}>
                    <div style={{ position: "relative", left: buttonsLeftMargin, top: "10px", fontSize: "18px", color: "gray" }}>
                        Inkluderte Bygningsdeler:
                    </div>
                </div>)

                const keyStr2 = (keyIndex++).toString()

                {/* build parts title area */ }
                elements.push(<div key={keyStr2} style={{ width: "100%", height: (artsTitleHeight.toString() + "px"), display: "flex", flexDirection: "row", fontSize: "18px" }}>
                    <div style={{ width: "35px" }} >
                    </div>

                    <div style={{ width: "35px", color: "gray", borderBottom: "1px solid #808080", position: "relative", top: "-2px" }} >
                        Antall
                    </div>

                    <div style={{ width: "45px", color: "gray", borderBottom: "1px solid #808080", position: "relative", top: "-2px" }} >
                    </div>

                    <div style={{ width: "350px", color: "gray", borderBottom: "1px solid #808080", position: "relative", top: "-2px" }} >
                        Byggdel
                    </div>

                    <div style={{ width: "120px", color: "gray", textAlign: "right", borderBottom: "1px solid #808080", position: "relative", top: "-2px" }} >
                        Pris
                    </div>

                    <div style={{ width: "140px", color: "gray", textAlign: "right", borderBottom: "1px solid #808080", position: "relative", top: "-2px" }} >
                        Sum
                    </div>
                </div>)
            }

            var parts = this.props.buildPart.GetIncludedBuildParts()
            for (var i = 0; (i < parts.length) && (showingExtended == true); i++) {
                const keyStr = (keyIndex++).toString()
                if (parts[i].amount != 0) {
                    elements.push(<div key={keyStr} style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                        <div style={{ width: "35px" }}></div>
                        <div style={{ color: "grey", width: "35px" }}>{parts[i].amount}</div>
                        <div style={{ color: "grey", width: "45px" }}></div>
                        <div style={{ color: "grey", width: "350px" }}>{parts[i].ref.GetTitle()}</div>
                        <div style={{ color: "grey", width: "120px", textAlign: "right" }}>{parts[i].ref.GetPriceString(radioPos, flags)}</div>
                        <div style={{ color: "grey", width: "140px", textAlign: "right" }}>{this.GetAsTwoDecimalString(parts[i].ref.GetPrice(radioPos, flags) * parts[i].amount)}</div>
                    </div>)
                }
            }
        }

        var extAreaHeight = 0

        if (showingExtended == true) {
            // Article content section
            extAreaHeight += artsTitleHeight
            extAreaHeight += titleHeight
            extAreaHeight += (BPAmount * itemHeight) 

            // Included buildparts section
            extAreaHeight += (SubBPAmount * itemHeight)
            extAreaHeight += (SubBPAmount != 0) ? titleHeight : 0 // Adding space for the title above included buildparts
            extAreaHeight += (SubBPAmount != 0) ? artsTitleHeight : 0 // Adding space for the row of titles above included buildparts
            extAreaHeight += (SubBPAmount != 0) ? separationMargin : 0 // Adding space for separation margin
            extAreaHeight += 10 // Bottom margin

            // Edit buildpart section
            extAreaHeight += buildEditAreaHeight
        }

        var totHeight = (itemsHeight + extAreaHeight).toString() + "px"
        var topHeight = itemsHeight.toString() + "px"

        // Hovering or selecting the item will cause it to render with some visual differences, and hoverstyle (below) holds the final set of characteristics to be rendered
        var hoverstyle = { width: '100%', height: totHeight, borderTop: '1px solid white', borderBottom: '1px solid white' }
        var hoverstyle_hover = { width: '100%', height: totHeight, backgroundColor: '#EAf3FF', borderTop: '1px solid #EAf3FF', borderBottom: '1px solid #EAf3FF' }
        var hoverstyle_selected = { width: '100%', height: totHeight, backgroundColor: '#EAf3FF', borderTop: '1px solid #CAd3dF', borderBottom: '1px solid #CAd3dF' }
        var favStr = ""
        var extInfoArrowOffset = 7
        var extInfoArrowShow = false // If or not the ext info dropdown arrow should be displayed

        // When the selected article is being hovered, the arrow to collapse/expand the extended info will light up a bit
        if (this.props.core.GetSelectionSetManager().GetHoveredBuildPartIndex() == this.props.index) {
            hoverstyle = hoverstyle_hover
            extInfoArrowOffset += 68
        }

        // If ext info is shown, the arrow will point upward as to show it can be hidden by clicking the article again
        if (this.props.core.GetApp().state.ExtInfoUp == true) {
            extInfoArrowOffset += 34
        }

        // Only the selected article can have an arrow to hide/show the extended info
        if (this.isSelected()) {
            this.props.core.ConnectSelectedBuildPartItem(this)
            hoverstyle = hoverstyle_selected
            extInfoArrowShow = true
        }

        if ( this.props.core.GetSelectionSetManager().GetHoveredBuildPartIndex() == this.props.index ) {
            hoverstate = "over"
        }

        var extensionArea = <div></div>

        const bgPosition = "0px -" + extInfoArrowOffset.toString() + "px"
        var isVisible = (this.isSelected()) ? "visible" : "hidden"
        var extArrowStyle: React.CSSProperties  = { width: "25px", height: "20px", backgroundImage: "url(images/UtvidetInfoLocalArrow.png)", backgroundPosition: bgPosition, visibility: isVisible, position: "relative", top: "4px", left: "0px" }
        
        if (showingExtended == true) {
            mergeOffsetX = "-33px"
            mergeOffsetY = "-29px"

            if (this.state.mergeButtonState == 2) {
                mergeOffsetX = "-97px"
                mergeOffsetY = "-29px"
            }

            if (this.state.mergeButtonState == 3) {
                mergeOffsetX = "-97px"
                mergeOffsetY = "-58px"
            }

            loadOffsetX = "-0px"
            loadOffsetY = "-29px"

            if (this.state.loadButtonState == 2) {
                loadOffsetX = "-64px"
                loadOffsetY = "-29px"
            }

            if (this.state.loadButtonState == 3) {
                loadOffsetX = "-64px"
                loadOffsetY = "-58px"
            }

            delOffsetX = "-128px"
            delOffsetY = "-29px"

            if (this.state.delButtonState == 2) {
                delOffsetX = "-160px"
                delOffsetY = "-29px"
            }

            if (this.state.delButtonState == 3) {
                delOffsetX = "-160px"
                delOffsetY = "-58px"
            }

            // Putting together the background image position
            var loadBgPosition = loadOffsetX + " " + loadOffsetY
            var mergeBgPosition = mergeOffsetX + " " + mergeOffsetY
            var delBgPosition = delOffsetX + " " + delOffsetY
            
            extensionArea = <div onMouseEnter={e => this.onMouseEnterExt()} style={{ width: "100%", height: (extAreaHeight.toString() + "px") }}>
                {/* title area */}
                <div style={{ width: "100%", height: (titleHeight.toString() + "px") }}>
                    <div style={{ position: "relative", left: buttonsLeftMargin, top: "10px", fontSize: "18px", color: "gray" }}>
                        Innhold:
                    </div>
                </div>

                {/* articles title area */}
                <div style={{ width: "100%", height: (artsTitleHeight.toString() + "px"), display: "flex", flexDirection: "row", fontSize: "18px" }}>
                    <div style={{ width: "35px" }} >
                    </div>

                    <div style={{ width: "35px", color: "gray", borderBottom: "1px solid #808080", position : "relative", top:"-2px" }} >
                        Ant
                    </div>

                    <div style={{ width: "45px", color: "gray", borderBottom: "1px solid #808080", position: "relative", top: "-2px" }} >
                        Enh
                    </div>

                    <div style={{ width: "350px", color: "gray", borderBottom: "1px solid #808080", position: "relative", top: "-2px" }} >
                        Varetext
                    </div>

                    <div style={{ width: "120px", color: "gray", textAlign: "right", borderBottom: "1px solid #808080", position: "relative", top: "-2px" }} >
                        Pris
                    </div>

                    <div style={{ width: "140px", color: "gray", textAlign: "right", borderBottom: "1px solid #808080", position: "relative", top: "-2px" }} >
                        Sum
                    </div>
                </div>

                {elements}

                <div style={{ width: "100%" }}>
                    <div style={{ width: "100%", height: "50px" }}>
                        <div style={{ position: "relative", left: buttonsLeftMargin, top: "17px", fontSize: "18px", color: "gray" }}>
                            Håndtere bygningsdel:
                        </div>
                    </div>

                    <div style={{ display: "flex", flexDirection: "row", width: "100%", height: buttonsAreaHeight }}>

                        {/* Left margin */}
                        <div style={{ width: buttonsLeftMargin, height:"1px" }} ></div>

                        {/* Load Button */}
                        <div style={{ width: "32px", height: "30px", backgroundImage: bgFile, backgroundPosition: loadBgPosition }}
                            onClick={this.OnMouseClickLoadButton.bind(this)}
                            onMouseOut={e => this.OnMouseOutLoadButton(e)}
                            onMouseEnter={e => this.OnMouseOverLoadButton(e)}
                            onMouseDown={e => this.OnMouseDownLoadButton(e)}
                            onMouseUp={e => this.OnMouseUpLoadButton(e)}>
                        </div>

                        {/* Center margin */}
                        <div style={{ width: buttonsCenterMargin, height: "1px" }} ></div>

                        {/* Load Button Description */}
                        <div style={{ fontSize : "16px", position:"relative", top:"4px", color:"gray" }}>
                            Hente innhold som nytt utvalg
                        </div>
                    </div>

                    <div style={{ display: "flex", flexDirection: "row", width: "100%", height: buttonsAreaHeight }}>

                        {/* Left margin */}
                        <div style={{ width: buttonsLeftMargin, height: "1px" }} ></div>

                        {/* Load Button */}
                        <div style={{ width: "32px", height: topHeight, backgroundImage: bgFile, backgroundPosition: mergeBgPosition }}
                            onClick={this.OnMouseClickMergeButton.bind(this)}
                            onMouseOut={e => this.OnMouseOutMergeButton(e)}
                            onMouseEnter={e => this.OnMouseOverMergeButton(e)}
                            onMouseDown={e => this.OnMouseDownMergeButton(e)}
                            onMouseUp={e => this.OnMouseUpMergeButton(e)}>
                        </div>

                        {/* Center margin */}
                        <div style={{ width: buttonsCenterMargin, height: "1px" }} ></div>

                        {/* Load Button Description */}
                        <div style={{ fontSize: "16px", position: "relative", top: "4px", color: "gray" }}>
                            Addere innhold til utvalg
                        </div>
                    </div>

                    <div style={{ display: "flex", flexDirection: "row", width: "100%", height: buttonsAreaHeight }}>

                        {/* Left margin */}
                        <div style={{ width: buttonsLeftMargin, height: "1px" }} ></div>

                        {/* Load Button */}
                        <div style={{ width: "32px", height: topHeight, backgroundImage: bgFile, backgroundPosition: delBgPosition }}
                            onClick={this.OnMouseClickDeleteButton.bind(this)}
                            onMouseOut={e => this.OnMouseOutDeleteButton(e)}
                            onMouseEnter={e => this.OnMouseOverDeleteButton(e)}
                            onMouseDown={e => this.OnMouseDownDeleteButton(e)}
                            onMouseUp={e => this.OnMouseUpDeleteButton(e)}>
                        </div>

                        {/* Center margin */}
                        <div style={{ width: buttonsCenterMargin, height: "1px" }} ></div>

                        {/* Load Button Description */}
                        <div style={{ fontSize: "16px", position: "relative", top: "4px", color: "gray" }}>
                            Slett bygningsdel
                        </div>
                    </div>
                </div>
            </div>
        }
        else {
            totHeight = "0px"
        }

        if (hoverstate == "over") {
            return <div onMouseEnter={e => this.OnItemEnter(e)} onMouseOut={e => this.onMouseOut()} onClick={this.onClick.bind(this)} style={hoverstyle}>
                <div style={{ display: "flex", flexDirection: "row", width: "100%", height: topHeight }}>
                    {/* Ext Info arrowdown area */}
                    <div style={{ width: "5px" }} >
                    </div>

                    <div style={extArrowStyle} >
                    </div>

                    <div style={{ width: "5px" }} >
                    </div>

                    <div style={{ width: "117px" }}>
                        <ChoiseControlBuildPart core={this.props.core} buildPartItem={this} />
                    </div>
                    
                    <div style={{ width: rightMargin, height: "1px" }}></div>

                    <div style={{ width: "305px", fontSize: itemFontSize, color: "grey", position: "relative", top: itemYAdjustment  }}>{this.props.buildPart.GetTitle()}
                    </div>

                    <div style={{ width: "120px", fontSize: itemFontSize, color: "grey", textAlign: "right", position: "relative", top: itemYAdjustment  }}>{this.props.buildPart.GetPriceString(radioPos, flags)}
                    </div>

                    <div style={{ width: "140px", fontSize: itemFontSize, color: "grey", textAlign: "right", position: "relative", top: itemYAdjustment  }}>{this.props.buildPart.GetTotalSumString(radioPos, flags)}
                    </div>

                </div>
                {extensionArea}
            </div>
        }
        else {
            // Selected means the background will be toned and should be so on the buttons to
            if (this.isSelected() == true) {
                mergeOffsetX = "-33px"
                mergeOffsetY = "-29px"
                loadOffsetX = "-0px"
                loadOffsetY = "-29px"
                delOffsetX = "-128px"
                delOffsetY = "-29px"
            }

            // Putting together the background image position
            var loadBgPosition = loadOffsetX + " " + loadOffsetY
            var mergeBgPosition = mergeOffsetX + " " + mergeOffsetY
            var delBgPosition = delOffsetX + " " + delOffsetY

            return <div onMouseEnter={e => this.OnItemEnter(e)} onMouseOut={e => this.onMouseOut()} onClick={this.onClick.bind(this)} style={hoverstyle}>
                <div style={{ display: "flex", flexDirection: "row", width: "100%", height: topHeight }}>
                    {/* Ext Info arrowdown area */}
                    <div style={{ width: "5px" }} >
                    </div>

                    <div style={extArrowStyle}>
                    </div>

                    <div style={{ width: "5px" }} >
                    </div>

                    <div style={{width:"117px"}}>
                        <ChoiseControlBuildPart core={this.props.core} buildPartItem={this} />
                    </div>
                    
                    <div style={{ width: rightMargin, height: "1px" }}></div>

                    <div style={{ width: "305px", fontSize: itemFontSize, color: "grey", position:"relative", top: itemYAdjustment }}>{this.props.buildPart.GetTitle()}
                    </div>
                    
                    <div style={{ width: "120px", fontSize: itemFontSize, color: "grey", textAlign: "right", position: "relative", top: itemYAdjustment  }}>{this.props.buildPart.GetPriceString(radioPos, flags)}
                    </div>

                    <div style={{ width: "140px", fontSize: itemFontSize, color: "grey", textAlign: "right", position: "relative", top: itemYAdjustment  }}>{this.props.buildPart.GetTotalSumString(radioPos, flags)}
                    </div>

                </div>
                {extensionArea}
            </div>
        }
    }

    // Returns true if the article held by this item is the one currently selected within the application
    isSelected() {
        return (this.props.core.GetSelectionID() == this.props.buildPart.GetId()) == true
    }

    onMouseEnterExt() {
        this.setState({ mouseState: "out" })
    }

    // Load button handlers
    OnMouseClickLoadButton(e: React.MouseEvent<HTMLDivElement>) {
        this.SetLocation("load")
        this.props.core.GetSelectionSetManager().loadProject(this.props.buildPart.GetSet())
    }

    OnMouseOutLoadButton(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ loadButtonState: 1 })
        this.forceUpdate()
    }

    OnMouseOverLoadButton(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ loadButtonState: 2 })
        this.forceUpdate()
    }

    OnMouseDownLoadButton(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ loadButtonState: 3 })
        this.forceUpdate()
    }

    OnMouseUpLoadButton(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ loadButtonState: 2 })
        this.forceUpdate()
    }

    // Merge button Handlers
    OnMouseClickMergeButton(e: React.MouseEvent<HTMLDivElement>) {
        this.SetLocation("merge")
        this.props.core.GetSelectionSetManager().mergeProject(this.props.buildPart.GetSet())
    }

    OnMouseOutMergeButton(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ mergeButtonState: 1 })
        this.forceUpdate()
    }

    OnMouseOverMergeButton(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ mergeButtonState: 2 })
        this.forceUpdate()
    }

    OnMouseDownMergeButton(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ mergeButtonState: 3 })
        this.forceUpdate()
    }

    OnMouseUpMergeButton(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ mergeButtonState: 2 })
        this.forceUpdate()
    }

    // Delete button Handlers
    OnMouseClickDeleteButton(e: React.MouseEvent<HTMLDivElement>) {
        this.SetLocation("delete")
        this.props.core.GetSelectionSetManager().onDeleteRequestBP(this.props.buildPart.GetSet())
    }

    OnMouseOutDeleteButton(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ delButtonState: 1 })
        this.forceUpdate()
    }

    OnMouseOverDeleteButton(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ delButtonState: 2 })
        this.forceUpdate()
    }

    OnMouseDownDeleteButton(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ delButtonState: 3 })
        this.forceUpdate()
    }

    OnMouseUpDeleteButton(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ delButtonState: 2 })
        this.forceUpdate()
    }

    OnItemEnter(e: React.MouseEvent<HTMLDivElement>) {
        this.props.core.GetSelectionSetManager().SetHoveredBuildPartIndex(this.props.index)
        this.setState({ mouseState: "hover" })
        this.m_choiseCtrl.setState({ hovering: true })
    }

    GetIsHovered() {
        if (this.props.core.GetSelectionSetManager().GetHoveredBuildPartIndex() == this.props.index) {
            return true
        }
        else {
            return false
        }
    }
    
    m_choiseCtrl: ChoiseControlBuildPart
    private m_clickedArea: string // This is set by the various controls being clicked, then reset to "none" in onClick for the entire item, after the click has been handled
}



// WEBPACK FOOTER //
// ./client/view/BuildPartItem.tsx